import PriceWithCurrency from "@/components/Helpers/PriceWithCurrency";
import React from "react";

const LastSection = ({ totalPrice, Context, t, push, loading }) => {
  return (
    // A flex sibling of the scroll area rather than a sticky overlay, so it can
    // never be pushed past the visible viewport.
    <div className="shrink-0 z-[100] w-full py-4 bg-white border-t overflow-hidden rounded-br-md shadow-[-2px_0px_10px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-between mx-4 mb-2">
        <h3 className="text-[16px] font-semibold">{t("Total Price")}</h3>
        <h4 className="flex items-center gap-2 text-[18px] font-semibold">
          {loading ? (
            <span className="inline-block h-5 w-24 rounded bg-gray-200 animate-pulse" />
          ) : (
            <PriceWithCurrency
              amount={Math.round(totalPrice)?.toLocaleString()}
              iconClassName="w-4 h-4"
              className="gap-2"
            />
          )}
        </h4>
      </div>
      <div className="flex flex-col gap-2 px-4">
        <button
          onClick={() => {
            push("/cart");
            Context?.dispatch({ type: "closeModal", payload: "" });
          }}
          className="w-full h-[60px] p-2 font-semibold rounded-lg bg-[#EFEFEF]"
        >
          {t("GoToCartPage")}
        </button>
        <button
          onClick={() => {
            Context?.dispatch({ type: "closeModal", payload: "" });
          }}
          className="w-full h-[60px] p-2 font-semibold border rounded-lg bg-primary text-white campaign:bg-campaignAccent"
        >
          {t("ContinueShopping")}
        </button>
      </div>
    </div>
  );
};

export default LastSection;
